import React, { useCallback } from "react"
import { Provider } from "react-redux"
import {
  CartProvider,
  CustomerProvider,
  SearchProvider,
  AppProvider,
  WindowProvider,
  WindowCtx,
  useActions,
  AppCtx,
} from "@components/contexted"

import store from "@stores"

import Loader from "./InitLoading"

const onAppInit = (dispatch) => {}

const onInitSearchData = (appLoaded) => (dispatch) => {
  appLoaded()
}

const OuterProviders = ({ children }) => {
  if(typeof window !== "undefined"){
    localStorage.setItem('language','/pl')
  }
  return (
    <WindowProvider>
      <AppProvider onLoad={onAppInit}>{children}</AppProvider>
    </WindowProvider>
  )
}

const InnerProviders = ({ children }) => {
  const { loaded } = useActions(AppCtx, "loaded")
  const onLoadSearchData = useCallback(onInitSearchData(loaded))

  return (
    <Provider store={store}>
      <CustomerProvider onLoad={onLoadSearchData}>
        <CartProvider>
          <Loader />
          {children}
        </CartProvider>
      </CustomerProvider>
    </Provider>
  )
}

export default ({ element }) => {
  return (
    <OuterProviders>
      <InnerProviders>{element}</InnerProviders>
    </OuterProviders>
  )
}

export { WindowCtx }
